

export const setTempStorge = (values) => {
  if(!window) return;
  const data = {
    ...values,
    timeStamp: Date.now()
  }
  window.localStorage.setItem(
    "tempMetric", JSON.stringify(data)
  )
}

export  const getTempStorge = () => {
  if(!window) return {};
  const now = Date.now();
  const data =  window.localStorage.getItem("tempMetric");
  if(!data || ((now - JSON.parse(data).timeStamp) > 21600000)) {
    return {}
  }
  return JSON.parse(data);
}


// WEBPACK FOOTER //
// ./src/misc/metrics/timeLimitMetric.js